module.exports = __webpack_public_path__ + "img/bingo_ball-58.184c99c4.png";